/**
* jQuery core object.
*
* Worker with jQuery deferred
*
* Code from: https://github.com/jquery/jquery/blob/master/src/core.js
*
*/
var jQuery = module.exports = {
  type: type,
  isArray: isArray,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  each: each,
  extend: extend,
  noop: function noop() {}
};
var toString = Object.prototype.toString;
var class2type = {}; // Populate the class2type map

"Boolean Number String Function Array Date RegExp Object".split(" ").forEach(function (name) {
  class2type["[object " + name + "]"] = name.toLowerCase();
});

function type(obj) {
  return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
}

function isFunction(obj) {
  return jQuery.type(obj) === "function";
}

function isArray(obj) {
  return jQuery.type(obj) === "array";
}

function each(object, callback, args) {
  var name,
      i = 0,
      length = object.length,
      isObj = length === undefined || isFunction(object);

  if (args) {
    if (isObj) {
      for (name in object) {
        if (callback.apply(object[name], args) === false) {
          break;
        }
      }
    } else {
      for (; i < length;) {
        if (callback.apply(object[i++], args) === false) {
          break;
        }
      }
    } // A special, fast, case for the most common use of each

  } else {
    if (isObj) {
      for (name in object) {
        if (callback.call(object[name], name, object[name]) === false) {
          break;
        }
      }
    } else {
      for (; i < length;) {
        if (callback.call(object[i], i, object[i++]) === false) {
          break;
        }
      }
    }
  }

  return object;
}

function isPlainObject(obj) {
  // Must be an Object.
  if (!obj || jQuery.type(obj) !== "object") {
    return false;
  }

  return true;
}

function extend() {
  var options,
      name,
      src,
      copy,
      copyIsArray,
      clone,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length,
      deep = false; // Handle a deep copy situation

  if (typeof target === "boolean") {
    deep = target;
    target = arguments[1] || {}; // skip the boolean and the target

    i = 2;
  } // Handle case when target is a string or something (possible in deep copy)


  if (typeof target !== "object" && !jQuery.isFunction(target)) {
    target = {};
  } // extend jQuery itself if only one argument is passed


  if (length === i) {
    target = this;
    --i;
  }

  for (; i < length; i++) {
    // Only deal with non-null/undefined values
    if ((options = arguments[i]) != null) {
      // Extend the base object
      for (name in options) {
        src = target[name];
        copy = options[name]; // Prevent never-ending loop

        if (target === copy) {
          continue;
        } // Recurse if we're merging plain objects or arrays


        if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)))) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && jQuery.isArray(src) ? src : [];
          } else {
            clone = src && jQuery.isPlainObject(src) ? src : {};
          } // Never move original objects, clone them


          target[name] = jQuery.extend(deep, clone, copy); // Don't bring in undefined values
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  } // Return the modified object


  return target;
}

;